module.exports = __webpack_public_path__ + "img/2-5.8514116c.svg";